import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { getBlockById } from '../services/BlockServices';
import { getAmenityById, createAmenity, updateAmenity } from '../services/AmenityServices'; // Asumimos que tienes estos servicios
import { getStageById } from '../services/StageServices';
import { MediaContext } from '../context/MediaContext';
import MediaItems from '../components/MediaItems';

import './Forms.css';
import { getProjectById } from '../services/ProjectServices';

function AmenityForm() {
  const { type, id, amenityId } = useParams();
  const [amenity, setAmenity] = useState({
    name: '',
    slug: '',
    description: '',
    floor: 0,
    area: '',
    type: type || 'block',
    icon: '',
    glbCode: '',
    parentId: id || null,
    createdAt: ""
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { mediaItems, setMediaItems } = useContext(MediaContext);
  const [parent, setParent] = useState(null);
  const [projectSlug, setProjectSlug] = useState('');
  const [mediaSaveMessage, setMediaSaveMessage] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Si estamos editando una amenidad, obtener sus datos
        if (amenityId) {
          const amenityData = await getAmenityById(amenityId);
          if (amenityData) {
            if (!amenityData.mediaItems)
              amenityData.mediaItems = [];
            setAmenity(amenityData);
            setMediaItems(amenityData.mediaItems);
          } else {
            setError('No se encontró la amenidad');
          }
        } else {
          const today = new Date().toISOString().split("T")[0];
          setAmenity(prev => ({ ...prev, createdAt: today }));
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [amenityId, setMediaItems]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Si estamos editando una amenidad, obtener sus datos
        if (type === 'block' && id) {
          const blockData = await getBlockById(id);
          if (blockData) {
            setParent(blockData);
            const stageData = await getStageById(blockData.stageId);
            const projectData = await getProjectById(stageData?.projectId);
            setProjectSlug(projectData?.slug);
          } else {
            setError('No se encontró el bloque');
          }
        } else if (type === 'stage' && id) {
          const stageData = await getStageById(id);
          if (stageData) {
            setParent(stageData);
            const projectData = await getProjectById(stageData.projectId);
            setProjectSlug(projectData?.slug);
          } else {
            setError('No se encontró la etapa');
          }
        }
      } catch (error) {
        setError(error.message);
      }
    };

    fetchData();
  }, [id, type]);

  const handleNameChange = (e) => {
    const newName = e.target.value;
    const newSlug = (parent?.slug ?? "amenity") + "-" + newName.toLowerCase().replace(/[^\w\s]/gi, '').replace(/\s+/g, '-');
    setAmenity({ ...amenity, name: newName, slug: newSlug });
  };

  const handleSave = async () => {
    if (!amenityId) return;

    try {
      amenity.mediaItems = mediaItems;
      amenity.id = amenityId;
      amenity.parentId = parent.id;
      await updateAmenity(amenityId, amenity);
      setMediaSaveMessage("¡MediaItem guardado exitosamente!");
      setTimeout(() => setMediaSaveMessage(""), 3000);
    } catch (error) {
      setError(error.message);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError(null);
      setLoading(true);
      if (amenityId) {
        await updateAmenity(amenityId, amenity);
      } else {
        await createAmenity(amenity);
      }
      if (type === 'block') {
        navigate(`/blocks/edit/${parent.stageId}/${id}`);
      } else {
        navigate(`/stages/edit/${parent.projectId}/${id}`);
      }

    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Cargando...</div>;
  }

  return (
    <div className="page-container">

      <div className="form-container">
        <h2>{amenityId ? 'Editar Amenidad' : 'Nueva Amenidad'}</h2>
        {error && (
          <div>
            <div className='error-message'>
              Hubo un error: {error}
            </div>
            <br />
          </div>
        )}
        <form onSubmit={handleSubmit}>

          <div className="form-group">
            <label htmlFor="amenity-createdAt">Fecha de creación</label>
            <input
              type="date"
              id="amenity-createdAt"
              value={amenity.createdAt || ""}
              disabled
              readOnly
            />
          </div>

          <div className="form-group">
            <label htmlFor="amenity-name">Nombre</label>
            <input
              type="text"
              id="amenity-name"
              value={amenity.name}
              onChange={handleNameChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="amenity-description">Descripción</label>
            <textarea
              id="amenity-description"
              value={amenity.description}
              onChange={(e) => setAmenity({ ...amenity, description: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="amenity-floor">Piso</label>
            <input
              type="number"
              id="amenity-floor"
              value={amenity.floor}
              onChange={(e) => setAmenity({ ...amenity, floor: e.target.value ? parseInt(e.target.value) : '' })}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="amenity-area">Área</label>
            <input
              type="text"
              id="amenity-area"
              value={amenity.area}
              onChange={(e) => setAmenity({ ...amenity, area: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="amenity-area">Ícono</label>
            <input
              type="text"
              id="amenity-icon"
              value={amenity.icon}
              onChange={(e) => setAmenity({ ...amenity, icon: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="amenity-glb">Código GLB</label>
            <input
              type="text"
              id="amenity-glb"
              value={amenity.glbCode}
              onChange={(e) => setAmenity({ ...amenity, glbCode: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label htmlFor="amenity-slug">Slug (auto-generado)</label>
            <input
              type="text"
              id="amenity-slug"
              value={amenity.slug}
              readOnly
            />
          </div>

          <div className="form-group">
            <button type="submit" className="btn-submit">{id ? 'Guardar Cambios' : 'Agregar Amenidad'}</button>
          </div>
        </form>
        {type === 'block' && parent && (
          <div className="form-footer">
            <Link to={`/blocks/edit/${parent.stageId}/${id}`} className="back-link">Regresar al bloque</Link>
          </div>
        )}
        {type === 'stage' && parent && (
          <div className="form-footer">
            <Link to={`/stages/edit/${parent.projectId}/${id}`} className="back-link">Regresar a la etapa</Link>
          </div>
        )}
      </div>
      {amenityId && (
        <div className="stages-container">
          <MediaItems projectSlug={projectSlug} objectType='block' objectSlug={amenity.slug} />
          <br />
          <button className="btn-submit" onClick={() => handleSave()}>Grabar</button>
          {mediaSaveMessage && <div className="media-save-message">{mediaSaveMessage}</div>}
        </div>
      )}
    </div>
  );
}

export default AmenityForm;
